import { homeConstant } from 'actionTypes';
import { Reducer } from 'redux';
import { HomeActionTypes } from 'types/actions/home';
interface HomeState {
  listNotification: any[];
  num_as_read: number | null;
  num_of_unread?: number;
  isShowingTerms: boolean;
}

const initialState: HomeState = {
  listNotification: [],
  num_as_read: null,
  isShowingTerms: false,
};

const homeReducer: Reducer<HomeState, HomeActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case homeConstant.UPDATE_STATE_NOTIFICATION: {
      return {
        ...state,
        listNotification: action.payload?.data ?? [],
        num_as_read: action.payload?.num_of_unread ?? 0,
      };
    }
    case homeConstant.UPDATE_STATE_MARK_AS_READ_NOTIFICATION: {
      return {
        ...state,
        num_as_read: 0,
      };
    }
    case homeConstant.UPDATE_SHOW_TERMS_STATUS: {
      return {
        ...state,
        isShowingTerms: action.payload,
      };
    }
    default:
      return state;
  }
};

export default homeReducer;
